import React from "react"

import { Team } from "entities/teams/types/Team"
import { TeamActionHandlers } from "features/team-management/types/TeamActionHandlers"

import { TeamListView } from "./TeamListView"

export interface TeamListModel {
  userID: string | null | undefined
  teams: Team[] | null | undefined

  isLoading?: boolean

  hasError?: boolean

  handlers?: Partial<TeamActionHandlers>

  getTeamHref: (team: Team) => string
  onTeamSelect: (team: Team) => void
}

export interface TeamListProps extends TeamListModel {}

export const TeamList = React.memo((props: TeamListProps) => {
  return <TeamListView {...props} />
})
